import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Header, Sidebar } from '@widgets';
import { useStyles } from './styles';

export const AppLayout = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const classes = useStyles();

  return (
    <>
      <Sidebar open={drawerOpen} openDrawer={() => setDrawerOpen(true)} closeDrawer={() => setDrawerOpen(false)} />
      <main className={classes.main}>
        <Header onToggleDrawer={() => setDrawerOpen((prev) => !prev)} />
        <div className={classes.content}>
          <Outlet />
        </div>
      </main>
    </>
  );
};
